import { render, staticRenderFns } from "./BoxInfo.vue?vue&type=template&id=c954d018&scoped=true&"
import script from "./BoxInfo.vue?vue&type=script&lang=js&"
export * from "./BoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./BoxInfo.vue?vue&type=style&index=0&id=c954d018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c954d018",
  null
  
)

export default component.exports